jQuery(document).ready(function(){


	// Smallslider

	$('.smallslider').each(function() {

	  var sliderIdName = this.id
		
	  var sliderId = '#' + sliderIdName;

	  $(sliderId).slick({
			dots: false,
			arrows: true,
			infinite: true,
			speed: 500,
			fade: false,
			slidesToShow: 1,
			cssEase: 'linear',
			autoplay: true, 
			autoplaySpeed: '3000',
			pauseOnHover: true,
			prevArrow:"<i class='slidearrow a-left slick-prev fas fa-arrow-left'></i>",
	  	nextArrow:"<i class='slidearrow a-right slick-next fas fa-arrow-right'></i>"
	  });


	});	
});







// WEBPACK FOOTER //
// ./js/parts/slider.js